module.exports = __webpack_public_path__ + "static/media/gp.0dcdf966.svg";